/* Constants for Header Starts*/
import React from "react";

export const MACYS_HOME = "MACY’S VENDOR MANAGEMENT SYSTEM HOME";
export const VENDOR_ONBOARDING = "VENDOR ONBOARDING";
export const MY_DASHBOARD = "MY DASHBOARD";
export const LOGO_ALT_TEXT = "logo";
export const HAMBERGER_ALT_TEXT = "hamberger";
export const TITLE = "VENDOR MANAGEMENT SYSTEM";
export const VENDOR_DELETED_SUCCESS_MSG = "Vendor deleted successfully";
/* Constants for Header Ends*/

/* Global Landing Starts */
export const NOTIFICATIONS = "NOTIFICATIONS";
export const MY_APPLICATION = "MY APPLICATIONS";
export const COM_NEWS = "COMPANY NEWS";
export const RESOURCES = "RESOURCES";
export const VSP_LINK_NAME = "Vendor Shipping Portal";
/* Global Landing Ends */

/* Constants for Onboard Vendor Starts*/
export const VOB_THANK_YOU = "Thank You";
/* export const VOB_CONF_MESSAGE =
  "We have received your Company Details for Registration process. Our VDF ops team/Merchant will review and will reach out to you if you need any additional information required for approval process";
 */
export const VOB_CONF_MESSAGE_PART1 = "We received your ";
export const VOB_CONF_MESSAGE_PART2 =
  "Company Details, Address Details, and Contact Details. ";
export const VOB_CONF_MESSAGE_PART3 =
  "Our merchandising team will review your submission and reach out regarding next steps.";
export const VOB_CONF_MESSAGE_PART4 =
  "If you have further questions about the onboarding process, please contact your merchant.";
export const VOB_NO_VENDOR_SELECTED_MSG =
  "Please select a vendor record through the search bar above.";
export const VOB_EXT_VENDOR_REGISTRATION_PROCESSING_MSG_PREFIX = "Notice: ";
export const VOB_EXT_VENDOR_REGISTRATION_PROCESSING_MSG =
  "Your registration from Macy’s Partners is still processing. This is an automated process and will be finished in less than 10 minutes. No action is required on your part. Please check back shortly in order to begin your submission through our Vendor Management System.";

export const EXCLAMATION = "!";
export const COMMA = ",";
export const VERBIAGE_COMPANY_DETAILS = "Company Details";
export const VERBIAGE_NOTES_DETAILS = "Notes";
export const VERBIAGE_BRAND_DETAILS =
  "Merchant Approval - Brand Mapping and DVN-Level Attributes";
export const VERBIAGE_BRAND_NEW_AND_EXISTING =
  "Note: The same brand name cannot be listed as both 'New' and 'Existing'.";
export const VERBIAGE_DVN_BRAND_DETAILS =
  "DVN Setup - Brand Mapping and DVN-Level Attributes";
export const COMPANY_DETAILS_DESC =
  "Received Basic information for registration approval";
export const VERBIAGE_PRE_BOARDING = "Pre-Boarding";
export const VERBIAGE_EIN_VERIFICATION = "EIN Verification";
export const VERBIAGE_DVN_AUDIT = "DVN Audit";
export const PRE_BOARDING_DESC =
  "We need your Blank Invoice, Company Letter head and any minority docs";
export const VERBIAGE_INTEGRATION = "Integration";
export const VERBIAGE_PUBLISH = "Publish";
export const INTEGRATION_DESC_YET_START = "Yet to start…";
export const PUBLISH_DESC_YET_START = "Yet to start…";
export const VOB_NEXT_STEPS = "Next Steps… Yet to Start…..";
export const MORE_ABT_VOBPROCESS = "KNOW ABOUT MACYS VENDOR ONBOARDING PROCESS";
export const VOBPROCESS_SUBMITTED_INFO = "VIEW YOUR SUBMITTED INFORMATION";
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const VERBIAGE_ADDRESS_TITLE = "Address Details";
export const VERBIAGE_CONTACT_TITLE = "Contact Details";
export const VERBIAGE_COMPANY_TITLE = "COMPANY DETAILS";
export const YES = "Yes";
export const NO = "No";
export const SELECT = "Select";
export const SELECT_ONE = "Select One";
export const REQUIRED = "required";
export const BUTTON_VALIDATE = "VALIDATE";
export const BUTTON_REVALIDATE = "RE VALIDATE";
export const BUTTON_CONTINUE = "CONTINUE";
export const BUTTON_PREVIOUS = "PREVIOUS";
export const BUTTON_SAVE_FOR_LATER = "SAVE FOR LATER";
export const BUTTON_SAVE_AS_DRAFT = "SAVE AS DRAFT ";
export const BUTTON_SUBMIT = "SUBMIT";
export const ADDITIONAL_PRODUCT_FULFILLMENT_TYPE =
  "ADDITIONAL PRODUCT/FULFILLMENT TYPE";
export const LOCATION_ID_LABEL = "Location ID";
export const LOCATION_NAME_LABEL = "Location Name";
export const STATUS_LABEL = "Status";
export const COMPANY_NAME_LABEL = "Company/ Legal/ Billing Name";
export const CORP_NAME_PLACE_HOLDER = "Macy's Merchandising Group";
export const DUNS_CREATION_BY_MACYS_MSG =
  "If you don’t have existing DUNS number, it will be created for you by Macy’s Inc.";
export const DUNS_VALIDATION_SUCCESS_MSG = "Validated Successfully.";
export const CORP_VALIDATION_SUCCESS_MSG = "Validated Successfully.";
export const DUNS_PLACE_HOLDER = "123456789";
export const COMPANY_NAME_LABEL_HELP_TEXT =
  "Vendor's legal company name for billing.";
export const DUNS_LABEL = "Duns #";
export const DUNS_LABEL_HELP_TEXT =
  "Vendor company's unique nine-digit identifier.";
export const CERT_MINORITY_POC_TEXT =
  "Please make sure you MUST complete worksheet 4 and provide proof of certification at the time of pre boarding process.";
export const ADDRESS_CLARIFICATION_TEXT = "Your Primary address is same for";
export const BILLING_TEXT = "Billing";
export const SHIPPING_TEXT = "Shipping";
export const SHIPPING_EDIT = "Edit";
export const SHIPPING_ADD = "Add";
export const OTHER_ADDRESS_LINK = "+ Add Other Address";
export const DELETE_ADDRESS_LINK = " Delete Address";
export const DELETE_CONATCT_LINK = " Delete Contact";
export const UPDATE_ADDRESS = "Update Address";
export const VOB_HOME_ID = "vobHome";
export const ASSIGN_NEW_DVN = "Assign new DVN #";
export const DBM_MESSAGE =
  "Please select a DBM from the dropdown. A request will be sent via email to that DBM for approval.";
export const DEI_APPROVAL_CONFIRMATION_TITLE =
  "DIVERSITY EQUITY & INCLUSION APPROVAL";
export const DEI_APPROVAL_CONFIRMATION_TEXT =
  "By selecting either of the buttons below, this vendor will move to Accounts Payable and/or Merch Ops for DVN creation and additional onboarding";
export const DEI_EXP_DATE_CERT_AFFIDAVIT =
  "Expiration date of certificate/affidavit:";
export const DEI_NOTE_EXP_DATE_CERT_AFFIDAVIT =
  "(NOTE: Certificate date must be entered, affidavit date is pre-populated from generated MBE/WBE document)";
export const DEI_APP_NO_OPT_CONFIRM_TXT =
  "By selecting OKAY button below, this vendor will move to Accounts Payable and/or Merch Ops for DVN creation and additional onboarding";
export const ACTION_REQUIRED_IN_MAINFRAME = "Action Required in Mainframe";
/* Constants for Onboard Vendor Ends*/

/* Constant for welcome page starts */
export const VERBIAGE_WELCOME_MESSAGE_PART1 =
  "We are looking forward to our partnership with you as a vendor with Macy’s Inc. Here you will find everything you need to complete the vendor on boarding process and start selling your product.";
export const VERBIAGE_WELCOME_MESSAGE_PART2 =
  "Below is a quick overview of the steps that need to be completed for on boarding:";
// export const COMPANY_DETAILS_SECTIONS = "Address & Contact details";
// export const PREBOARDING_SECTIONS = "Upload documentation";
// export const INTEGRATION_SECTIONS = "Shopping & EDI validation";

export const COMPANY_DETAILS_SECTIONS =
  "Provide Company, Address and Contact Details";
export const PREBOARDING_SECTIONS =
  "Provide Blank Invoice, Company Letterhead and Minority documents (if applicable) and Contract signing";
export const INTEGRATION_SECTIONS =
  "Provide Packing Slip & Shipping Label, Complete Order & 846 testing";
export const PUBLISH_SECTIONS =
  "Vendor Live Preparation and Launch on Macy's Inc.";

export const WELCOME = "Welcome";
export const LETS_GET_STARTED = "LETS GET STARTED";

/* Constant for welcome page ends */

/*onboarding buttons in onboarding header start*/
export const OB_HEAD_NOTIFICATION_TXT = "Notifications";
export const OB_HEAD_ONBOARDING_TXT = "Onboarding";
export const OB_HEAD_DOC_CENTER_TXT = "Document Center";
export const OB_HEAD_DOC_CENTER_TXT_ID = "DocumentCenter";
export const OB_HEAD_NOTES_TXT = "Notes";
export const OB_HEAD_VEND_MASTER_TXT = "Vendor Master";
export const OB_HEAD_VEND_MASTER_TXT_ID = "VendorMaster";

export const OB_HEAD_PRG_NOTIFY_TXT = "Company Information ";
export const OB_HEAD_PRG_ONB_TXT = "Pre-Boarding";
export const OB_HEAD_PRG_ING_TXT = "Integration";
export const VP_USER_TYPE_INTERNAL = "internal";
export const VP_USER_TYPE_EXTERNAL = "ext";
export const VP_FLAG_Y = "Y";
export const VP_FLAG_N = "N";
export const VP_WELCOME_PAGE_URL = "/welcome";
export const VP_VOB_PAGE_URL = "/vob";
export const VP_VOB_HOME_PAGE_URL = "/boarding/vendor";
export const VP_DEFAULT_HOME_PAGE_URL = "/mvp";
export const VP_VOB_PAGE_1 = "(1 of 3)";
export const VP_VOB_PAGE_2 = "(2 of 3)";
export const VP_VOB_PAGE_3 = "(3 of 3)";
export const BUTTON_ACTIONS = "ACTIONS";
export const VENDOR_COMPANY_TYPE = "companyType";

export const VOB_MERCHANDISE_TYPE_MARKETPLACE = "MP";
export const VOB_MERCHANDISE_TYPE_OWNED_VENDOR = "Owned Inventory";
export const VOB_MERCHANDISE_TYPE_BOTH = "Both";
export const VOB_MERCHANDISE_TYPE_CONSIGNMENT = "Consignment";
export const CONSIGNMENT_TYPE = "consignment";
export const DEI_TYPE = "dei";
export const TEST_CONSIGNMENT_APVP_EMAIL = "vms@macys.com";

export const VENDOR_SIGN_ORDER = {
  [CONSIGNMENT_TYPE]: 2,
  [DEI_TYPE]: 1,
};
export const VP_SIGN_ORDER = {
  [CONSIGNMENT_TYPE]: 1,
  [DEI_TYPE]: 2,
};

export const FLAGS_MBE_STATUS = {
  MINORITY_OWNED: "YES",
  NOT_MINORITY_OWNED: "NO",
};
export const FLAGS_MBE_GROUPS = {
  ASIAN_PACIFIC_AMERICAN: "ASIAN_PACIFIC_AMER",
  ASIAN_INDIAN_AMERICAN: "ASIAN_IND_AMER",
  BLACK_AFRICAN_AMERICAN: "BLK_AFRICAN_AMER",
  HISPANIC_AMERICAN: "HISPANIC_AMER",
  NATIVE_AMERICAN: "NATIVE_AMER",
  LGBTQ: "LGBTQ",
  PERSON_DISABILITY: "DISABILITY",
  VETERAN: "VETERAN",
};
export const FLAGS_WBE_STATUS = {
  WOMEN_OWNED: "YES",
  NOT_WOMEN_OWNED: "NO",
};
export const FLAGS_BUSINESS_ORGS = {
  MACYS: "MCY",
  BLOOMS: "BLM",
  BLUEM: "BLUM",
};

export const ACTION_OPTIONS_REQUEST_VENDOR_LABEL =
  "Request more details from vendor";
export const ACTION_OPTIONS_INACTIVE_STATUS_VENDOR_LABEL =
  'Move vendor to "Inactive" status';
export const ACTION_OPTIONS_REQUEST_MERCHANT_LABEL =
  "Request more details from merchant";
export const ACTION_OPTIONS_RETURN_TO_MERCHANT_LABEL = "Return to merchant";
export const ACTION_OPTIONS_DVN_AUDIT_NOTES_LABEL = "DVN Audit Notes";
export const ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS_LABEL =
  'Remove vendor from "Inactive" status';
export const ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS_TEXTBOX_LABEL =
  'Are you sure you wish to remove this vendor from "Inactive" status?';
export const ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN_LABEL =
  "Request more details from Consignment Admin";
export const ACTION_OPTIONS_REQUEST_DELETE_VENDOR_LABEL = "Delete vendor ";
export const ACTION_OPTIONS_DELETE_VENDOR_TEXTBOX_LABEL =
  "Are you sure you want to delete this vendor permanently?";

export const ACTION_OPTIONS_REQUEST_VENDOR = "requestVendor";
export const ACTION_OPTIONS_REQUEST_MERCHANT = "requestMerchant";
export const ACTION_OPTIONS_RETURN_TO_MERCHANT = "returnToMerchant";
export const ACTION_OPTIONS_DVN_AUDIT_NOTES = "dvnAuditNotes";
export const ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS =
  "removeVendorInActiveStatus";
export const ACTION_OPTIONS_INACTIVE_STATUS_VENDOR = "inactiveStatusVendor";
export const ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN =
  "requestConsginmentAdmin";
export const ACTION_OPTIONS_DELETE_VENDOR = "deleteVendor";

export const ACTION_OPTIONS_SUBMIT_TO_MERCHANT = "submittedToMerchOps";
export const ACTION_OPTIONS_SUBMIT_TO_MERCHANT_LABEL = "Submit to Merch ops";

export const ACTION_REQUEST_VENDOR_MESSAGE_PLACEHOLDER =
  "The text in this box will be sent to the contacts of this vendor via email.";
export const ACTION_REQUEST_MERCHANT_MESSAGE_PLACEHOLDER =
  "The text in this box will be sent to the merchant contacts for this vendor via email.";
export const ACTION_RETURN_TO_MERCHANT_MESSAGE_PLACEHOLDER =
  "The text in this box will be submitted as a note and sent to the merchant via email.";
export const ACTION_DVN_AUDIT_NOTES_MESSAGE_PLACEHOLDER =
  "The text in this box will be sent via email to the AP Admin(s) that created a DVN # for this vendor or to the AP Audit team (depending on your role in VMP).";
export const ACTION_REQUEST_INACTIVE_STATUS_VENDOR_PLACEHOLDER =
  "The text in this box will be submitted as a note and will be sent via email to relevant internal team members. The vendor will not be notified.";
export const ACTION_REQUEST_CONSIGNMENT_ADMIN_MESSAGE_PLACEHOLDER =
  "The text in this box will be sent to the Consignment Admin contacts via email.";
export const ACTION_REQUEST_DELETE_VENDOR_MESSAGE_PLACEHOLDER =
  "Please provide reason of deleting this vendor.";
export const ACTION_SUBMIT_BUTTON = "SUBMIT";

/*onboarding buttons in onboarding header start*/

/* Constants for Contact Details page starts*/
export const VENDOR_CONTACT_ROLE = "role";
export const VENDOR_CONTACT_ADDL_ROLE = "additionalJobRole";
export const VENDOR_CONTACT_PRIMARY = "Primary";
export const VENDOR_CONTACT_TECHNICAL = "Technical";
//export const VENDOR_CONTACT_SALES_REP = "SalesRep";
export const VENDOR_CONTACT_CUSTOMER_SER = "CustomerService";
export const VENDOR_CONTACT_SHIPPING = "Shipping";
export const VENDOR_CONTACT_OTHER = "Other";
export const VENDOR_CONTACT_SUCCESS_MESSAGE =
  "Details are updated successfully";
export const VENDOR_CONTACT_ERROR_MESSAGE =
  "Problem in adding a vendor contact, try after sometime!";
export const Contacts = ["Primary", "Technical", "SalesRep"];
export const contactKeys = [
  "vendorProfileId",
  "vendorCorpName",
  "category",
  "jobRole",
  "duns",
  "userEmail",
];
export const VENDOR_CONTACT_VENDOR = "Vendor";
export const VENDOR_CONTACT_ID = "id";
export const VENDOR_CONTACT_CREATE_DATE = "createdDate";
export const VENDOR_CONTACT_UPDATE_DATE = "updatedDate";
export const VENDOR_CONTACT_PRIMARY_VENDOR = "primaryVendor";
export const VENDOR_CONTACT_ENTER_CONTACT_TYPE = "enterContactType";
export const VENDOR_CONTACT_ADDL_JOB_ROLE = "additionalJobRole";
export const VENDOR_CONTACT_PHONE_NUMBER = "phoneNumber";
/* Constants for Contact Details page ends*/

export const VP_MA_SB_CI_HEAD = "COMPANY INFORMATION";
export const VP_MA_SB_CI_COMPANY_DET = "Company Details";
export const VP_MA_SB_CI_ADDRESS_DET = "Address Details";
export const VP_MA_SB_CI_CONTACT_DET = "Contact Details";
export const VP_MA_SB_CI_MERCH_APP = "Merchant Approval";

export const VP_MA_SB_PB_HEAD = "PRE BOARDING";
export const VP_MA_SB_PB_DOC_CENTER = "Document Center";
export const VP_MA_SB_PB_SIGN_CONTRACT = "Review Contract";
export const VP_MA_SB_PB_REVIEW_CONTRACT = "Review Contract";
export const VP_MA_SB_PB_UPS_ACCOUNT = "Shipping Carrier";
export const VP_MA_SB_PB_VENDOR_PROFILE = "Vendor Profile";
export const VP_MA_SB_PB_SET_DVN = "DVN Setup";
export const VP_MA_SB_PB_EIN_VERIFICATION = "EIN Verification";
export const VP_MA_SB_PB_DVN_AUDIT = "DVN Audit";

export const VP_MA_SB_INT_HEAD = "INTEGRATION";
export const VP_MA_SB_INT_PS = "Packing Slip";
export const VP_MA_SB_INT_SL = "Shipping Label";
export const VP_MA_SB_INT_ORDER = "Order Testing";
export const VP_MA_SB_INT_846 = "846 Testing";
export const VP_MA_SB_INT_TABLE_SETUP = "Table Setup";
export const VP_MA_SB_INT_QUALITY_LEADER = "Quality Leader Approval";
export const VP_MA_SB_INT_EVP_AND_ERP_SETUP = "EVP and ERP Setup";
export const VP_MA_SB_INT_ITEM_SKU_SETUP = "Item / SKU Setup";

export const VP_MA_SB_INT_BOSS = "BOSS Agreement";

export const VP_MA_SB_LIVE_HEAD = "PUBLISH";
export const VP_MA_SB_LIVE_VLL = "Vendor Line List";
export const VP_MA_SB_LIVE_PAGE_CREATION = "Page Creation";
export const VP_MA_SB_LIVE_ONBOARD_COMPL = "Onboarding Complete";
export const VP_MA_SB_LIVE_LIVE = "Live";

export const VENDORPLATFORM_MAIN_HEAD_SHIPPINGLOCATION = "SHIPPING LOCATIONS";
export const VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS = "Shipping Location List";
export const VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS = "Routing Request";
export const BUTTON_ADD_NEW_LOCATION = "ADD NEW LOCATION";
export const SHIPPING_LOCATION_TITLE = "Shipping Location";
export const SHIPPING_LOCATION_INFORMATION = "Location Information";
export const ROUTING_REQUEST_MESSAGE = "to create a Shipment/Routing Request";

/*Constants for Merchant Approval page starts */
export const MERCHANT_APPROVAL_TITLE = "Merchant Approval";
export const MERCHANT_APPROVED = "Merchant Approved";
export const REQUEST_MORE_DETAILS = "Request More Details";
export const CUSTOM_VENDOR_MSG =
  "Check this box to send the vendor a custom message";
export const BUTTON_APPROVE = "APPROVE";
export const BUTTON_REJECT = "REJECT";
export const BUTTON_SEND = "SEND";
export const BUTTON_SUBMIT_CHANGES = "Submit Changes";
export const BUTTON_MANAGE_MERCHANT_CONTACTS = "MANAGE MERCHANT CONTACTS";
export const ENTER_EMAIL_PLACE_HOLDER =
  "Please add your quick notes to send email to Vendor";
export const MERCHANT_APPROVAL_MSG = {
  MERCHANT_APPROVED: "Approved",
  MERCHANT_APPROVAL_ERROR_MSG:
    "Problem in Merchant Approval for Vendor, try after sometime!",
};
export const API_INIT_ADOBE_SIGN_ERROR_MSG =
  "Unable to Initiate Adobe Sign Process, try after sometime.";
export const API_ERROR_MSG = "Something went wrong, try after sometime.";
export const API_GET_AGREEMENT_ERROR_MSG = "Error fetching agreement details.";
export const AGGREMENT_PENDING_FOR_CEO_SIGN =
  "Agreement pending for CEO to be Sign.";

export const BIG_TKT_VENDOR_FLAG = "Direct EDI RDS";
export const NEW_BIG_TKT_VENDOR_FLAG = "directEdiRDS";
export const SELECT_ALL_APPLY = "Select all that apply";
export const VENDOR_SUBMISSION = "Vendor Submission";
export const DOCUMENT_SUBMITTED = "Documents Submitted";
export const CONSIGNMENT_ADMIN_PENDING = "Consignment Admin Pending";
export const ACCOUNTS_PAYABLE_VP_PENDING = "Accounts Payable VP Pending";
export const ACCOUNTS_PAYABLE_APPROVED = "Accounts Payable Approved";
export const CONSIGNMENT_VENDOR_PENDING = "Consignment Vendor Pending";
export const GMM_PENDING = "GMM Pending";
export const CHIEF_MERCHANT_PENDING = "Chief Merchant Pending";
export const MANAGE_MERCHANT_CONTACTS_TITLE = "Manage Merchant Contacts";
export const ADD_OTHER_MERCHANT = "+ Add Other Merchant";
export const DELETE_MERCHANT = "- Delete Merchant";
export const BUTTON_OK = "Ok";
export const BUTTON_SAVE = "SAVE";
export const BUTTON_CANCEL = "CANCEL";
export const VENDOR_REGISTRATION = "Vendor Registration";
export const CONTACT_SUBMISSION = "Submission successful";
export const VENDOR_STATUS_PROGRESS_INPROCESS = "In Process";
export const HOLD_STATE = "On Hold";
export const MERCHANT_APPROVAL_SUBMIT_TO_DBM = "SUBMIT TO DBM";
export const MERCHANT_APPROVAL_SUBMIT_TO_DMM_GMM = "SUBMIT TO DMM AND GMM";
export const SELECT_DMM_LABEL = "Please select a DMM from the dropdown:";
export const SELECT_GMM_LABEL = "Please select a GMM from the dropdown:";
export const DMM_GMM_MESSAGE =
  "A request will be sent via email to the DMM, GMM and Chief Merchant for apporval of a new consignment vendor at Bloomingdale's";
export const MERCHANT_CLASS_LEVEL_MAPPING = "Class-Level Mapping*";
export const BUTTON_BEGIN_INTEGRATION = "BEGIN INTEGRATION";
export const CONTENT_BEGIN_INTEGRATION =
  'By selecting the "Submit" button, this vendor will move to "In Process" status. By this point, the vendor should be ready to begin EDI testing.';
export const BLOOMINGDALES_DIVISION_NUMBER = 13;
/*Constants for Merchant Approval page ends */
export const ACCOUNT_PAYABLE_VP_REVIEW = "accountsPayableVPReview";
export const ACCOUNT_PAYABLE_VP = "accountsPayableVP";
export const BDS_GMM = "bdsGMM";
export const BDS_CHIEF_MERCHANT = "bdsChiefMerchant";
/*Constants for Vendor Master page starts */
export const VEND_MASTER_TITLE = "Vendor Masters";
/*Constants for Vendor Master page ends */

export const ONBOARDING_STATUS = "onboardingStatus";
export const MERCHANT_APPROVAL_ID = "merchantApproval";
export const UPLOAD_DOCUMENT_ID = "uploadDocuments";
export const DVN_SET_UP_ID = "setupDvn";
export const UPLOAD_CONTRACT_ID = "uploadContract";
export const UPS_ACCOUNT_ID = "upsAccount";
export const UPDATE_VENDOR_PROFILE = "updateVendorProfile";
export const UPLOAD_PACKING_SLIP_ID = "uploadPackingSlip";
export const UPLOAD_SHIPPING_LABEL_ID = "uploadShippingLabel";
export const ORDER_TESTING_ID = "orderTesting";
export const TESTING_846_ID = "eightFortySixTesting";
export const BOSS_AGREEMENT = "bossAgreement";
export const TABLE_SETUP = "tableSetup";
export const QUALITY_LEADER_APPROVAL = "qualityLeaderApproval";
export const EVP_AND_ERP_SETUP = "evpAndErpSetup";
export const ITEM_SKU_SETUP = "itemOrSkuSetup";
export const COMPLETE_VLL_ID = "completeVll";
export const PAGE_COMPLETE_ID = "pageComplete";
export const ONBOARDING_COMPLETE_ID = "onboardingComplete";
export const LIVE_ID = "live";
export const EIN_VERIFICATION_ID = "einVerification";
export const DVN_AUDIT_ID = "dvnAudit";
export const HOLD_ID = "hold";

export const VENDOR_STATUS = {
  merchantApproval: "Not Started",
  setupDvn: "Not Started",
  uploadContract: "Not Started",
  uploadPackingSlip: "Not Started",
  uploadShippingLabel: "Not Started",
  orderTesting: "Not Started",
  eightFortySixTesting: "Not Started",
  bossAgreement: "Not Started",
  completeVll: "Not Started",
  pageComplete: "Not Started",
  live: "Not Started",
  uploadDocuments: "Not Started",
};

/* Dashboard constants Starts */
export const VENDOR_PIPELINE_STATUS = "Vendor Pipeline Status";
export const MY_TASKS = "My Tasks";
export const NOT_STARTED = "Not Started";
export const IN_PROCESS = "In Process";
export const IN_PROGRESS = "In Progress";
export const COMPLETED = "Completed";
export const PENDING = "Pending";
export const APPROVED = "Approved";
export const MY_VENDORS = "My Vendors";
export const ALL_VENDORS = "All Vendors";
export const MY_TEAM = "My Team";
export const ADD_VENDOR = "Add Vendor";
export const NEW_VENDORS = "New Vendors";
export const REPORTS_EXPORTS = "Reports";
export const ACCESS_REQUESTS = "Access Requests";
export const EMAIL_ADMIN = "Email Admin";
export const DBM_APPROVAL = "DBM Approval";
export const DBM_APPROVED = "DBM Approved";
export const MBE_WBE_VENDORS_APPROVAL = "MBE/WBE Vendors";
export const MBE_WBE_SEND_EMAIL = "MBE/WBE Email";
export const DEI_PENDING = "DEI Pending";
export const MANAGE_MP_INBOUND = "Manage MP Inbound";
export const ASSIGN = "Assign";
export const APPROVE_PACKING_SLIP = "Approve Packing Slip";
export const APPROVE_SHIPPING_LABEL = "Approve Shipping Label";
export const COMPLETE_EIGHTFORTYSIX_TESTING = "Complete 846 Testing";
export const COMPLETE_ORDER_TESTING = "Complete Order Testing";
export const COMPLETE_BOSS_AGREEMENT = "Complete Boss Agreement";
export const PREPARE_TO_GO_LIVE = "Prepare to Go Live";
export const ASSIGN_UPS_ACCOUNT = "Assign UPS account";
export const MERCHANT_APPROVAL = "Merchant Approval";
export const CONTRACT_MANAGEMENT = "Contract Management";
export const VLL = "Vendor Line List";
export const PAGE_COMPLETE = "Pages Complete";
export const SETUP_DVN = "Setup Dvn";
export const TOTAL = "Total";
export const OB_COMPLETE = "Onboarding Complete";
export const ON_HOLD = "On Hold";
export const OFF_HOLD = "Off Hold";
export const COMPLETE = "Complete";
export const LIVE = "Live";
export const STATUS_UPLOAD_DOCUMENTS = "Upload Documents";
export const STATUS_REVIEW_CONTRACT = "Review Contract";
export const STATUS_TABLE_SETUP = "Table Setup";
export const STATUS_QUALITY_LEADER_APPROVAL = "Quality Leader Approval";
export const STATUS_EVP_ERP_SETUP = "EVP AND ERP Setup";
export const STATUS_ITEM_SKU_SETUP = "Item/SKU Setup";
export const STATUS_PLATFORMTYPE_CHUB = "chub";
export const STATUS_PLATFORMTYPE_DIRECTEDI = "directEdi";
export const STATUS_PLATFORMTYPE_DIRECTEDIRDS = "directEdiRDS";
export const STATUS_PLATFORMTYPE_MIRAKL = ["mcymirakl", "blmmirakl"];
export const STATUS_PLATFORMTYPE_MULTI = "multi";
export const STATUS_INACTIVE_INTEGRATION_HOLD = "Inactive - Integration Hold";
export const STATUS_INACTIVE_UNRESPONSIVE = "Inactive - Unresponsive";
export const ONBOARDING_STATUS_REPORT_SMALL_TICKET_VDF =
  "Onboarding Status Report - Small Ticket VDF";
export const DETAILED_STATUS_REPORT_SMALL_TICKET_VDF =
  "Detailed Status Report - Small Ticket VDF";
export const ONBOARDING_STATUS_REPORT_BIG_TICKET_VDF =
  "Onboarding Status Report - Big Ticket VDF";
export const DETAILED_STATUS_REPORT_BIG_TICKET =
  "Detailed Status Report - Big Ticket";
export const PIPELINE = "Pipeline";
export const PREBOARDING = "Preboarding";
export const APPROVE_DENY = "Approve/Deny";
export const SEND_EMAIL = "Send Email";
export const ACCESS_REQUEST = "Access Request";
export const NEW_VENDOR_RECORD = "New Vendor Record";
export const DENY_REQUEST = "Deny Request";
export const DENY_BUTTON = "Deny";
export const APPROVE_BUTTON = "Approve";
export const SUBMIT_BUTTON = "Submit";
export const VIEW_MODIFY = "View/Modify";
export const RETRY_BUTTON = "Retry";
export const EMAIL_TEMPLATES = "Email templates";
export const ADD_VENDOR_SERVER_ERROR_TYPES = ["vendorCorpName", "corpEmailId"];
export const ADD_VENDOR_SERVER_ERROR_TYPES_MAP = {
  vendorCorpName: "vendorCorpName",
  corpEmailId: "corpEmailId",
  other: "other",
};
export const ADD_VENDOR_SERVER_ERROR_MSG_MAP = {
  vendorCorpName: "company name",
  corpEmailId: "email",
};
export const DBM_APPROVAL_MODAL_BUTTON_YES = "Yes";
export const DBM_APPROVAL_MODAL_BUTTON_CANCEL = "Cancel";
export const DBM_APPROVAL_MODAL_TITLE = "Submit to Accounts Payable";
export const DBM_APPROVAL_MODAL_BODY_TEXT =
  "All selected vendors will be submitted to Accounts Payable for DVN creation.";
export const DBM_APPROVAL_MODAL_BODY_QUESTION =
  "Are you sure you wish to proceed?";

export const GMM_CHIEFMERCHANT_APPROVAL_MODAL_BUTTON_YES = "YES";
export const GMM_CHIEFMERCHANT_APPROVAL_MODAL_BUTTON_NO = "NO";
export const GMM_CHIEFMERCHANT_APPROVAL_MODAL_TITLE =
  "Bloomingdales Consignment Approval";
export const GMM_CHIEFMERCHANT_APPROVAL_MODAL_QUESTION =
  "Are you sure you want to approve this vendor for consignment at Bloomingdales?";

export const MY_TASK_DVN_AUDIT = "dvnAudit";
export const MY_TASK_DVN_CREATION = "dvnCreation";

/* Dashboard constants Ends */

/*VendorInfo constants*/
export const VENDOR_INFO_HEADER = "Vendor Info: ";
export const BACK_TO_DASHBOARD = "BACK TO DASHBOARD";

/*VendorInfo constants*/

/*Constants for Company Details Page start*/
export const VENDOR_COMPANY_VENDOR = "Vendor";
export const VENDOR_DETAIL = "vendorDetail";
export const VENDOR_UPC_PROVIDED_BY = "vendorUPCsProvidedBy";
export const VENDOR_COMPANY_MACYS = "Macy's";
export const ADD_MORE = "+Add";

/*Constants for Company Details Page end*/

/*Constants for Document Center Page start*/
export const DOCUMENT_CENTER = "Document Center";
export const BOARDING_DOCUMENT = "Onboarding Documents";
export const VENDOR_FULFILLMENT_TYPE = "VDF";
export const BLANK_INVOICE_OR_COMPANY_LETTERHEAD =
  "BlankInvoice/CompanyLetterhead";
export const BLANK_INVOICE = "BlankInvoice";
export const COMPANY_LETTERHEAD = "CompanyLetterhead";
export const MINORITY_BUSINESS_DOCUMENTATION = "MinorityBusinessDocumentation";
export const MBE_WBE_BUSINESSDOCUMENTATION = "MBE/WBEBusinessDocumentation";
export const ADD_DOCUMENT = "+ Add Document";
export const GENERATE_CONTRACT = "Generate Contract";
export const PREVIEW = "Preview";
export const PREVIEW_CONTRACT = "Preview Contract";
export const EDIT = "Edit";
export const NOTE = "Note:";
export const EDIT_CONTRACT = "Edit Contract";
export const EDIT_CONTRACT_NOTE =
  "Add page-break to start with a new page in the document";
export const VIEW_MODIFY_CONTRACT = "View/Modify Contract";
export const VIEW_MBEWBE_CONTRACT = "View/Generate MBE/WBE Contract";
export const MBE_WBE_SEND_MAIL_SUCCESS_MESSAGE = "Email sent successfully.";
export const MBE_WBE_EXPIRATION_DATE_ERROR_MESSAGE =
  "Expiration Date should not be less than today's date.";
export const DATE_FIELD_ERROR_MESSAGE = "Invalid Date value.";
export const END_PROGRAM_DATE_FIELD_ERROR_MESSAGE =
  "End of Program Date should not be less than First Receipt Date.";
export const CLOSE = "Close";
export const REVIEW_CONSIGNMENT_CONTRACT = "Review Consignment Contract";
export const DOCUMENT_TYPE_W9 = "W9";
export const DOCUMENT_TYPE_FRIEGHT_TERMS = "FreightTermsExplanation";
export const CONSIGNMENT_CONTRACT_FIRST_DRAFT = "ConsignmentContractFirstDraft";
export const CONSIGNMENT_VENDOR_PENDING_STATUSNAME = "consignmentVendorPending";
export const DBM_SUBMISSION_STATUSNAME = "dbmSubmission";

/*Constants for Document Center Page end*/

/*Constants for LeftNav Permissions*/

export const VENDORPLATFORM_UPDATEPROFILE_ADDRESSSECTION_ADDRESS_EDIT =
  "VendorPlatform_UpdateProfile_AddressSection_Address_Edit";
export const VENDORPLATFORM_UPDATEPROFILE_COMPANYINFORMATION_VENDORPROFILE_EDIT =
  "VendorPlatform_UpdateProfile_CompanyInformation_VendorProfile_Edit";
export const VENDORPLATFORM_UPDATEPROFILE_CONTACTSECTION_CONTACT_EDIT =
  "VendorPlatform_UpdateProfile_ContactSection_Contact_Edit";
export const VENDORPLATFORM_UPDATEPROFILE_MERCHANTAPPROVAL_MERCHANT_EDIT =
  "VendorPlatform_UpdateProfile_MerchantApproval_Merchant_Edit";

export const VENDORPLATFORM_VENDORINFORMATION_SEARCH =
  "VendorPlatform_VendorInformation_Search";
export const VENDORPLATFORM_HOME_FILTERS_APPLYFILTERS_VIEW =
  "VendorPlatform_Home_Filters_View";
export const VENDORPLATFORM_VENDORINFORMATION_DASHBOARD_VIEW =
  "VendorPlatform_VendorInformation_Dashboard_View";

export const EXTERNAL_VENDOR_GENERIC = "externalVendorGeneric";
export const EXTERNAL_GENERIC_ADMIN = "externalGenericAdmin";
export const ROLE_OMNI_MERCHANT = "omniMerchantBuyer";
export const ROLE_MTO_MEMBER = "mtoTeamMember";
export const ROLE_MTO_ADMIN = "mtoAdmin";
export const VENDOR = "vendor";
export const MERCHANT = "Merchant";
export const VENDOROPS = "Ops";
export const APTEAM = "ap";
export const ACCOUNTS_PAYABLE_ADMIN = "accountsPayableAdmin";
export const CONSIGNMENT_ADMIN = "consignmentAdmin";
export const SELLERCENTRAL_ADMIN = "sellerCentralAdmin";
export const SELLERCENTRAL_EXTUSER = "sellerCentralExtUser";
export const VDF_OPS_ADMIN = "vdfOpsAdmin";
export const VDF_OPS_PIPELINE_OWNER = "vdfOpsPipelineOwner";

/*Constants for LeftNav Permissions End*/
/*Constants for OPS flow starts*/
export const VENDOR_PROFILE = "Vendor Profile";
export const VP_INT_START_DATE_LABEL = "Integration Start Date";
export const VP_HOLD_START_DATE_LABEL = "Hold Date";

/*Constants for OPS flow end*/

/*Dvn setup constants*/
export const DVN_SETUP = "DVN Setup";
export const REJECTED = "Rejected";
export const DVN_SETUP_STATUS_PENDING = "Pending";
export const DVN_SETUP_STATUS_COMPLETE = "Complete";
export const DVN_SETUP_STATUS_ERROR = "Error";
export const DVN_SETUP_STATUS_ERROR_BTN = "Error Details";
export const DVN_SETUP_MSG = {
  DVN_SETUP_UPDATED: "DVN setup updated successfully",
  DVN_SETUP_ERROR_MSG: "Problem in adding DVN setup, try after sometime!",
  DVN_SETUP_STATUS_PENDING_MSG: "DUNS/DVNs has been requested.",
  DVN_SETUP_STATUS_COMPLETE_MSG: "DUNS/DVN request has been completed.",
  DVN_SETUP_STATUS_ERROR_MSG: "There are errors in requested DUNS/DVN.",
};
export const REQUEST_MORE_DETAILS_VENDOR = "Request More Details from Vendor";
export const REQUEST_MORE_DETAILS_MERCHANT =
  "Request More Details from Merchant";
export const ENTER_VENDOR_EMAIL_PLACE_HOLDER =
  "The text in this box will be sent to the contacts of this vendor via email…";
export const ENTER_MERCHANT_EMAIL_PLACE_HOLDER =
  "The text in this box will be sent to the merchant contacts for this vendor via email…";
export const MSG_UNABLE_TO_SEND_EMAIL =
  "Unable to send email. Please try after some time";
export const MSG_UNABLE_TO_DELETE_VENDOR =
  "Unable to delete vendor. Please try after some time";
export const ASSIGN_NEW_DVNS_AND_DUNS = "ASSIGN NEW DVN’S AND DUNS #";
export const RETURN_TO_DVN_SETUP = "RETURN TO DVN SETUP";
export const RETURN_TO_MERCHANT_APPROVAL = "RETURN TO MERCHANT APPROVAL";
export const CLASS_LEVEL_MAPPING_DOC_MSG =
  "Please note: DVN creation is currently blocked for this vendor. Please ask a merchant to upload a Class-Level Mapping document to the Document Center. Once complete, DVN creation will unlock for this vendor.";
/*Dvn setup constants*/

/*DVN Audit constants */
export const BUTTON_AUDIT_COMPLETE = "AUDIT COMPLETE";
export const AUDIT_COMPLETE_MODAL_BODY_TEXT =
  "Are you sure you wish to approve the audit for this vendor record?";

/*DVN Audit constants */

/*Banner setup constants starts*/
export const BANNER_FLAG_Y = "Y";
export const BANNER_MSG_KEY = "message";
export const SHOW_BANNER_KEY = "showbanner";
export const BANNER_DATA_SIZE = 2;
/*Banner setup constants ends*/

/*SideNav active dropdown starts*/

export const COMPANYBRANDDETAILS = "showCompanySection";
export const COMPANYADDRESSDETAILS = "showAddressSection";
export const COMPANYCONTACTDETAILS = "showContactSection";
export const PREVENDORPROFILE = "showVendorProfileSection";
export const PREDVNSETUP = "showDvnSetup";
export const PREDOCUPLOAD = "showDocumentCenter";
export const PREREVIEWCONTRACT = "showReviewContract";
export const VENDORMASTER = "showVendorMasterSection";
export const INTEGRATION = "showIntegrationSection";
export const SIDENAVPUBLISH = "showPublishSection";
export const NOTESSECTION = "showNotesSection";

export const SIDENAVACTIVE = {
  showAddressSection: "0",
  showContactSection: "0",
  showCompanySection: "0",
  showVendorMasterSection: "0",
  showNotesSection: "0",
  showDvnSetup: "1",
  showVendorProfileSection: "1",
  showDocumentCenter: "1",
  showReviewContract: "1",
  showIntegrationSection: "2",
  showPublishSection: "3",
};

export const PARAMTYPE = {
  company: "0",
  address: "0",
  contact: "0",
  merchant: "0",
  notes: "0",
  documentCenter: "1",
  dvnsetup: "1",
  "vendor-profile": "1",
  reviewContract: "1",
};

// Route Name Per Shipping Locations Screen
export const SHIPPING = "shipping";
export const SHIPPING_LOCATION = "location";
export const BTN_REMOVE = "-Remove";
export const BOARDING = "boarding";
export const ACTIVE = "Active";
export const INACTIVE = "Inactive";

// Route Name Per Vendor Onboarding Screen
export const COMPANY = "company";
export const ADDRESS = "address";
export const CONTACT = "contact";
export const MERCH = "merchant";
export const PB_VENDOR_PROFILE = "vendor-profile";
export const DVNSETUP = "dvnsetup";
export const DOC_CENTER = "documentCenter";
export const REVIEW_CONTRACT = "reviewContract";
export const UPS_ACCOUNT = "upsAccount";
export const VENDOR_MASTER = "vendormaster";
export const NOTES = "note";
export const BRAND = "brand";
export const DVNBRAND = "dvnbrand";
export const EIN_VERIFICATION = "einverification";
export const DVN_AUDIT = "dvnaudit";
/*SideNav active dropdown ends*/

/*Consants for notes tab in onboarding starts */
export const NOTES_TYPE = {
  general: "General Note",
  merchantApproval: "Merchant Approval",
  uploadDocuments: "Documents",
  setupDvn: "DVN Setup",
  setupDvnSuffixes: "DVN Setup - Suffixes",
  dvnAudit: "DVN Audit",
  uploadContract: "Review Contract",
  upsAccount: "UPS Account",
  updateVendorProfile: "Vendor Profile",
  uploadPackingSlip: "Packing Slip",
  uploadShippingLabel: "Shipping Label",
  orderTesting: "Order Testing",
  eightFortySixTesting: "846 Testing",
  bossAgreement: "BOSS Agreement",
  tableSetup: "Table Setup",
  qualityLeaderApproval: "Quality Leader Approval",
  evpAndErpSetup: "EVP and ERP Setup",
  itemOrSkuSetup: "Item / SKU Setup",
  completeVll: "VLL",
  pageComplete: "Page Creation",
  onboardingComplete: "OB Complete",
  live: "Live",
};
/*Consants for notes tab in onboarding ends */
/**CSV Report Headers start*/

export const NOTEREPORTHEADERS = [
  { label: "Duns", key: "duns" },
  { label: "Date", key: "createdDate" },
  { label: "User", key: "updatedByFullName" },
  { label: "Note", key: "notes" },
  { label: "Note Type", key: "noteType" },
];
/**CSV Report Headers end*/

/*Consants for  Status report export tab in Dashboard ends */
/**CSV Report Headers start*/

export const ONBOARDINGSTATUSSMALLTICKETVDFREPORTHEADERS = [
  { label: "Vendor Name", key: "vendorName" },
  { label: "Duns", key: "duns" },
  { label: "Pipeline Ownership", key: "plOwnerShip" },
  { label: "MBE/WBE Status", key: "mbeWbeStatus" },
  { label: "VDF Platform", key: "vdfPlatform" },
  { label: "Selling Channel", key: "sellingChannel" },
  { label: "Dept #", key: "dept" },
  { label: "Ven #", key: "ven" },
  { label: "Onboarding Status", key: "onBoardingStatus" },
  { label: "# of Days - In Process", key: "noOfDaysInProcess" },
  { label: "# of Days - On Hold", key: "noOfDaysOnHold" },
  { label: "# of Days - OB Complete", key: "noOfDaysObComplete" },
  { label: "% Complete", key: "percentageComplete" },
  { label: "Annual Sales Volume", key: "annualSalesVolume" },
  { label: "Start Date", key: "startDate" },
  { label: "Target Live Date", key: "targetLiveDate" },
  { label: "OB Completed Date", key: "obCompleteDate" },
  { label: "Live Date", key: "liveDate" },
  { label: "Hold Status", key: "holdStatus" },
  { label: "Date Moved", key: "dateMoved" },
  { label: "Next Action Date", key: "nextActionDate" },
];

export const DETAILEDSTATUSREPORTHEADERS = [
  { label: "Vendor Name", key: "vendorName" },
  { label: "Duns", key: "duns" },
  { label: "Vendor Status", key: "vendorStatus" },
  { label: "# of Days - In Process", key: "noOfDaysInProcess" },
  { label: "# of Days - On Hold", key: "noOfDaysOnHold" },
  { label: "# of Days - OB Complete", key: "noOfDaysObComplete" },
  { label: "Pipeline Ownership", key: "plOwnerShip" },
  { label: "Target Live Date", key: "targetLiveDate" },
  { label: "Selling Channel", key: "sellingChannel" },
  { label: "MBE/WBE Status", key: "mbeWbeStatus" },
  { label: "VDF Platform", key: "vdfPlatform" },
  { label: "% Complete", key: "percentageComplete" },
  { label: "Integration Start Date", key: "integrationStartDate" },
  { label: "Merchant Approval Date", key: "merchantApprovalDate" },
  { label: "DVN Set up Date", key: "dvnSetupUpdateDate" },
  { label: "Review Contract", key: "reviewContract" },
  { label: "Review Contract Date", key: "reviewContractDate" },
  { label: "UPS Account", key: "upsApproved" },
  { label: "UPS Account Date", key: "upsApprovedDate" },
  { label: "Packing Slip", key: "packingSlip" },
  { label: "Packing Slip Date", key: "packingSlipDate" },
  { label: "Shipping Label", key: "shippingLabel" },
  { label: "Shipping Label Date", key: "shippingLabelDate" },
  { label: "Order Testing", key: "orderTesting" },
  { label: "Order Testing Date", key: "orderTestingDate" },
  { label: "846 Testing", key: "eightFourtyTesting" },
  { label: "846 Testing Date", key: "eightFourtyTestingDate" },
  { label: "BOSS Agreement", key: "bossAgreement" },
  { label: "BOSS Agreement Date", key: "bossAgreementDate" },
  { label: "Vendor Line List", key: "completeVll" },
  { label: "Page Creation", key: "pageCreationComplete" },
  { label: "OB Complete", key: "obComplete" },
  { label: "Live", key: "live" },
];

export const DETAILEDSTATUSREPORTBIGTICKETHEADERS = [
  { label: "Vendor Name", key: "vendorName" },
  { label: "Duns", key: "duns" },
  { label: "Pipeline Ownership", key: "plOwnerShip" },
  { label: "Target Live Date", key: "targetLiveDate" },
  { label: "Selling Channel", key: "sellingChannel" },
  { label: "Dept #", key: "dept" },
  { label: "Vendor #", key: "vendor" },
  { label: "MBE/WBE Status", key: "mbeWbeStatus" },
  { label: "VDF Platform", key: "vdfPlatform" },
  { label: "Annual Sales Volume", key: "annualSalesVolume" },
  { label: "Onboarding Status", key: "onBoardingStatus" },
  { label: "# of Days - In Process", key: "noOfDaysInProcess" },
  { label: "# of Days - On Hold", key: "noOfDaysOnHold" },
  { label: "# of Days - OB Complete", key: "noOfDaysObComplete" },
  { label: "Hold Status", key: "holdStatus" },
  { label: "Date Moved", key: "dateMoved" },
  { label: "Next Action Date", key: "nextActionDate" },
  { label: "% Complete", key: "percentageComplete" },
  { label: "Integration Start Date", key: "integrationStartDate" },
  { label: "Merchant Approval Date", key: "merchantApprovalDate" },
  { label: "DVN Set up Date", key: "dvnSetupUpdateDate" },
  { label: "Review Contract", key: "reviewContract" },
  { label: "Review Contract Date", key: "reviewContractDate" },
  { label: "UPS Approved", key: "upsApproved" },
  { label: "UPS Approved Date", key: "upsApprovedDate" },
  { label: "Packing Slip", key: "packingSlip" },
  { label: "Packing Slip Date", key: "packingSlipDate" },
  { label: "Shipping Label", key: "shippingLabel" },
  { label: "Shipping Label Date", key: "shippingLabelDate" },
  { label: "Order Testing", key: "orderTesting" },
  { label: "Order Testing Date", key: "orderTestingDate" },
  { label: "846 Testing", key: "eightFourtyTesting" },
  { label: "846 Testing Date", key: "eightFourtyTestingDate" },
  { label: "Table Setup", key: "tableSetup" },
  { label: "Table Setup Date", key: "tableSetupDate" },
  { label: "Quality Leader Approval", key: "qualityLeaderApproval" },
  { label: "Quality Leader Approval Date", key: "qualityLeaderApprovalDate" },
  { label: "EVP and ERP Setup", key: "evpAndErpSetup" },
  { label: "EVP and ERP Setup Date", key: "evpAndErpSetupDate" },
  { label: "Item / SKU Setup", key: "itemOrSkuSetup" },
  { label: "Item / SKU Setup Date", key: "itemOrSkuSetupDate" },
  { label: "Vendor Line List", key: "completeVll" },
  { label: "Page Creation", key: "pageCreationComplete" },
  { label: "OB Complete", key: "obComplete" },
  { label: "OB Complete Date", key: "obCompleteDate" },
  { label: "Live", key: "live" },
  { label: "Live Date", key: "liveDate" },
];

/**CSV Report Headers end*/

/**Address UPSAccountNumber */
export const UPS_ACCOUNT_NBR_LABEL = "UPS Acct #";
export const UPS_ACCOUNT_NBR_TOOLTIP = "UPS Account Number";
export const OPEN_RAN_NUM = "openRANumber";

/** Notifications */
export const NOTIFICATION_TYPE = {
  NOTIFICATION: "notification",
  RESOURCE: "resource",
};

/** Duns Numver Validation Msg */
export const DUNS_VALIDATION_ERROR_MSG =
  "Duns # must be nine numbers (ex: 000000123)";
export const DUNS_EXISTS_VALIDATION_ERROR_MSG =
  "Duns # already exists in VMP. Please contact your merchant.";
export const DUNS_DVN_EXISTS_VALIDATION_ERROR_MSG =
  "This Duns # already exists for a different vendor. Please enter a different Duns # to proceed.";

/** Merchant Email Validation Msg */
export const MERCHANT_EMAIL_ERROR_MSG =
  "The email address must end with @macys.com or @bloomingdales.com";
export const VALID_EMAIL_ERROR_MSG = "Enter valid email address";

export const MERCHANT_FIRST_NAME_ERROR_MSG =
  "The merchant first name may only contain letters, space, and special characters.";
export const MERCHANT_LAST_NAME_ERROR_MSG =
  "The merchant last name may only contain letters, space, and special characters.";

/** Brand URL Prefixing */
export const BRAND_URL_PREFIX = {
  HTTP: "http://",
  HTTPS: "https://",
  WWW: "www.",
  URL_PREFIX: "https://www.",
};

/** Constants for feature flag value (E for enabled, D for disabled) */
export const ENABLED_FLAG = "E";
export const DISABLED_FLAG = "D";

/** Constants for EPC Starts */
export const EPC_USER = "epcUser";
export const EPC_HOME_URL = "/mvp";
export const EPC_ADMIN = "epcAdmin";
/** Constants for EPC Ends */

export const MERCHANT_REJECTED_MSG = "Vendor details has been rejected.";
export const MERCHANT_APPROVED_MSG = "Vendor details has been approved.";
export const MERCHANT_APPROVED_SAVE_MSG =
  "Vendor details has been saved successfully.";
export const CONTACT_DISTINCT_MSG_ERROR =
  "You must provide at least two distinct contacts in order to proceed. Please provide an additional unique contact.";
export const CONTACT_DISTINCT_MSG =
  "*You must provide at least two distinct contacts in order to register";
export const UNIQUE_HIER_VALIDATION_ERROR_MSG =
  "All OpDiv/Dept/Vendor combination must be unique!";
export const UNIQUE_HIER_VALIDATION_MSG =
  "Selected OpDiv/Gmm/Division/Dept/Vendor combination is already added.";
export const UNIQUE_HIER_VALIDATION_MSG2 =
  "Selected OpDiv/Gmm/Division/Dept combination is already added.";
export const SERVER_ERROR_MSG = "Server Error: The vendor details not saved.";
export const VP_SAVE_ERR_MSG = "Unable to save form!";
export const VP_SAVE_SUCCESS_MSG = "Successfully saved form!";
export const VP_CHANGE_VDF_ERR_MSG =
  "Cannot change VDF Platform at this time. Please contact mtech for support.";
export const MA_CHANGE_VDF_ERR_MSG =
  "Cannot change VDF Platform at this time. Please contact Merchant Operations for support.";
export const UPS_SAVE_ERR_MSG = "Unable to save UPS addresses!";
export const UPS_SAVE_SUCCESS_MSG = "Successfully saved UPS addresses!";
export const TERMS_DAYS_ERROR_MSG =
  "Terms Days field value should not less than 30 and more than 999 days.";
export const TERMS_DAYS_NON_MINORITY_ERROR_MSG =
  "Terms Days field value should not less than 1 and more than 999 days.";
// Dashboard tiles constants
export const DASHBOARD_TILES_CONSTANTS = {
  merchantApproval: "Merchant Approval",
  uploadDocuments: "Upload Documents",
  setupDvn: "DVN Setup",
  uploadContract: "Review Contract",
  upsAccount: "UPS Account",
  uploadPackingSlip: "Packing Slip",
  uploadShippingLabel: "Shipping Label",
  orderTesting: "Order Testing",
  eightFortySixTesting: "846 Testing",
  bossAgreement: "BOSS Agreement",
  tableSetup: "Table Setup",
  qualityLeaderApproval: "Quality Leader Approval",
  evpAndErpSetup: "EVP and ERP Setup",
  itemOrSkuSetup: "Item / SKU Setup",
  completeVll: "Vendor Line List",
  pageComplete: "Page Creation",
  dvnAudit: "Audit",
  dvnCreation: "DVN Creation",
};

// MICROSERVICE name constants
export const MS_NAME = {
  DOCUMENT: "/document/",
  NOTES: "/notes/",
  NOTIFICATION: "/notification/",
  REPORT: "/reporting/",
  VENDORPROFILE: "/vendorplatform/",
  MARKETPLACE_VENDOR: "/marketplacevendor/",
  DOC_LIBRARY: "/mdocmanager/",
  FOM: "/user-management/",
};

export const USER_TYPE = "userType";
export const INTERNAL_UI = "internal";
export const INTERNAL_BACK_END = "Internal";
export const EXTERNAL_UI = "ext";
export const EXTERNAL_BACK_END = "External";

//Constants for new vendor request types
export const REQ_TYPE_NEW_REQUEST = "NEW_REQUEST";
export const REQ_TYPE_ACCESS_REQUEST = "ACCESS_REQUEST";

export const pageHeaderTitlesByRoute = {
  [COMPANY]: VERBIAGE_COMPANY_DETAILS,
  [ADDRESS]: VERBIAGE_ADDRESS_TITLE,
  [CONTACT]: VERBIAGE_CONTACT_TITLE,
  [MERCH]: MERCHANT_APPROVAL,
  [PB_VENDOR_PROFILE]: VENDOR_PROFILE,
  [DVNSETUP]: DVN_SETUP,
  [DOC_CENTER]: OB_HEAD_DOC_CENTER_TXT,
  [NOTES]: VERBIAGE_NOTES_DETAILS,
  [BRAND]: VERBIAGE_BRAND_DETAILS,
  [DVNBRAND]: VERBIAGE_DVN_BRAND_DETAILS,
  [EIN_VERIFICATION]: VERBIAGE_EIN_VERIFICATION,
  [DVN_AUDIT]: VERBIAGE_DVN_AUDIT,
  1: VP_MA_SB_INT_SL,
  2: VP_MA_SB_INT_ORDER,
  3: VP_MA_SB_INT_846,
  4: VP_MA_SB_INT_BOSS,
  5: VP_MA_SB_LIVE_VLL,
  6: VP_MA_SB_LIVE_PAGE_CREATION,
  7: VP_MA_SB_LIVE_LIVE,
  11: VP_MA_SB_PB_REVIEW_CONTRACT,
  10: VP_MA_SB_INT_PS,
  12: VP_MA_SB_LIVE_ONBOARD_COMPL,
  13: VP_MA_SB_INT_TABLE_SETUP,
  14: VP_MA_SB_INT_QUALITY_LEADER,
  15: VP_MA_SB_INT_EVP_AND_ERP_SETUP,
  16: VP_MA_SB_INT_ITEM_SKU_SETUP,
  17: VP_MA_SB_PB_UPS_ACCOUNT,
};

export const disableHierarchyStatuses = [
  VENDOR_REGISTRATION,
  ACCOUNTS_PAYABLE_APPROVED,
  VENDOR_STATUS_PROGRESS_INPROCESS,
  HOLD_STATE,
  VP_MA_SB_LIVE_ONBOARD_COMPL,
  LIVE,
];

export const DISPLAY_FOR_MP = "displayForMP";
export const DISPLAY_FOR_NON_MP = "displayForNonMP";
export const DISPLAY_FOR_ALL_DVN_AUDIT = "displayForAllDVNAudit";
export const MACYS = "MACY'S";
export const FREIGHT_CODE_100 = "FA100";
export const FREIGHT_CODE_PRPD = "PRPD";

export const ADDRESS_DETAILS = "ADDRESS DETAILS";
export const CONTACT_DETAILS = "CONTACT DETAILS";
export const SELLER_INFORMATION = "SELLER INFORMATION";

/*Seller Reports constants*/
export const SELLER_REPORTS_NOT_DISPLAY =
  "Your access to Seller Hub is revoked which prevents you to view report";
export const SELLER_REPORTS_LOAD_ERROR =
  "Error occurred while pulling report. Please try after sometime.";
//export const SELLER_REPORTS_PAGE_URL = "sellerreports/reports";

export const SELLER_REPORTS_PAGE_URL = "sellerreports/managereports";
export const USER_MANAGEMENT_URL = "manageusers";

export const OBJ_WEEK_DAYS = {
  Sun: "sunday",
  Mon: "monday",
  Tues: "tuesday",
  Wed: "wednesday",
  Thurs: "thursday",
  Fri: "friday",
  Sat: "saturday",
};

export const BLOOMINGDALES_EMAIL_DOMAIN = "@bloomingdales.com";

export const NO_DATA_FOUND = "No data found.";
export const ERROR_UNABLE_TO_DOWNLOAD_FILE =
  "Unable to download file, Please try again after some time.";
export const DOCUMENT_LIBRARY = "Document Library";
export const FILE_MIME_TYPE = {
  "application/vnd.oasis.opendocument.spreadsheet": "ods",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
  "application/vnd.ms-excel": "xls",
  "application/x-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
    "xltx",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
    "dotx",
  "application/mspowerpoint": "ppt",
  "application/oda": "oda",
  "application/onenote": "one",
  "application/xml": "xsl",
  "application/pdf": "pdf",
  "application/json": "json",
  "text/html": "html",
  "text/plain": "txt",
  "text/richtext": "rtx",
  "text/tab-separated-values": "tsv",
  "application/zip": "zip",
  "application/x-tar": "tar",
  "application/x-gzip": "gz",
  "application/x-gtar": "gtar",
  "application/msword": "doc",
  "image/gif": "gif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/bmp": "dib",
  "image/x-portable-bitmap": "pbm",
  "image/pict": "pict",
  "image/tiff": "tiff",
  "image/x-portable-graymap": "pgm",
};
export const ENABLE_DOC_LIBRARY = "E";
export const NO_DATA_AVAILABLE = "No data available";
export const REGEX_NUMBER_ZERO_TO_NINE = /^(?:9(?:\.0)?|[0-9](?:\.[0-9])?|0(?:\.[0-9])?)$/;
export const SALVAGE_ALLOWANCE_MIN_LIMIT = "0.1";
export const SALVAGE_ALLOWANCE_MAX_LIMIT = "9.9";
export const MSG_SALVAGE_ALLOWANCE_LIMIT_VALIDATION = `Salvage Allowance can not be less than ${SALVAGE_ALLOWANCE_MIN_LIMIT} and more than ${SALVAGE_ALLOWANCE_MAX_LIMIT}`;
export const REGEX_NUMBER_ZERO_TO_FIFTY = /^(?=.)(?:(?:(?:0|[1-4]?\d)?(?:[.]\d{1})?)|49(?:[.]0?)?)$/;
export const ALLOWANCE_MAX_LIMIT = "49.9";
export const MSG_ALLOWANCE_RATE_LIMIT_VALIDATION = `Receipt Allowance rate can not be less than ${SALVAGE_ALLOWANCE_MIN_LIMIT} and more than ${ALLOWANCE_MAX_LIMIT}`;
export const DOCUMENT_LIBRARY_RECENT_UPDATES =
  "Document Library Recent Updates";
export const DVN_CONSIGNMENT_SUFFIX_API_FAILURE_MESSAGE =
  "Error occurred. Please try after sometime.";
export const SIGNIN_APP_TITLE = "Vendor Management System";
export const SIGNIN_BTN_TXT = "SIGN IN";
export const SIGNIN_DOC_LIB_TXT = "Document Library Updates";
export const GET_ENV_ERR_MSG = "Unable to get config details.";
export const DOCUMENT_LIBRARY_TITLE = "Document Library";
export const LOADING = "Loading...";
export const DOC_LIB_MSG_NO_RECENT_UPDATES = "No recent updates on documents";
export const VIEW_MORE = "View More...";
export const LBL_DESCRIPTION = "Description";
export const LBL_PUBLISHED = "Published";
export const LBL_DOCUMENT = "Document";
export const LBL_LOGIN = "Login";
export const VENDOR_CONTACT_CUSTOMER_SERVICE = "customerservice";
export const NO_UPS_FEDEX_ACCT_FOUND = "No UPS account or Fedex account found!";

export const MANAGE_USER_ERROR_MSG = "There is a problem with the user data update! Please try again later.";
export const MANAGE_USER_SUCCESS_MSG = "User information has been successfully updated!"
export const MANAGE_USER_AUDIT_TRAIL = "Audit Trail"
export const MP_REQUEST_MORE_DATA_ID = "requestMoreDataIL"
export const MP_REQUEST_MORE_DATA_LABEL= "Request more details from marketplace onboarding"
export const MP = "MP"
export const ENTER_REASON_PLACEHOLDER = "Please enter the reason...";